/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import React, { useState } from 'react';
import { Channel } from '@wit/vtv-x-foundation-lib';

interface Props {
  channel: Channel;
  bemBlock: string;
}

export default function ChannelLogo({ channel, bemBlock }: Props): JSX.Element {
  const [error, setError] = useState(false);
  const id = `${bemBlock}_channelLogo___${channel.id}`;
  const uri = channel.logo?.white?.uri;

  const handleError = () => {
    setError(true);
  };

  return (
    <>
      {error || uri === undefined || uri === '' ? (
        <div className="channel-logo-component" id={id}>
          {channel.title}
        </div>
      ) : (
        <img
          className="channel-logo-component"
          id={id}
          src={uri}
          onError={handleError}
          alt=""
          crossOrigin="anonymous"
        />
      )}
    </>
  );
}
